import React, { useCallback } from 'react';
import { Button, FormControl } from '@mui/material';

import styles from './MultiSelectButtonGroup.module.scss';

interface MultiSelectButtonGroupProps {
  options: string[];
  selectedOptions: string[];
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
}

const MultiSelectButtonGroup: React.FC<MultiSelectButtonGroupProps> = ({
  options,
  selectedOptions,
  setSelectedOptions,
}) => {
  const handleToggle = useCallback(
    (option: string) => {
      setSelectedOptions((currentSelectedOptions) => {
        const currentIndex = currentSelectedOptions.indexOf(option);
        const newSelectedOptions = [...currentSelectedOptions];

        if (currentIndex === -1) {
          newSelectedOptions.push(option);
        } else {
          newSelectedOptions.splice(currentIndex, 1);
        }

        return newSelectedOptions;
      });
    },
    [setSelectedOptions],
  );

  return (
    <FormControl
      component="fieldset"
      className={styles.multiSelectButtonGroupWrapper}
      data-testid="multi-select-button-group"
    >
      {options.map((option) => (
        <Button
          className={styles.multiSelectButton}
          key={option}
          size="small"
          color="secondary"
          variant={selectedOptions.includes(option) ? 'primary' : 'secondary'}
          onClick={() => handleToggle(option)}
        >
          {option}
        </Button>
      ))}
    </FormControl>
  );
};

export default MultiSelectButtonGroup;
